module.exports = __webpack_public_path__ + "static/media/wefTestIsOver.9c53a150.mp3";